import { Injectable } from '@angular/core';
import { Hub } from 'aws-amplify/utils';
import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth';
import { Router } from '@angular/router';
import { StorageService } from './storage.service';
import { NavigationService } from './navigation.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  handleCognitoToken() {
    Hub.listen('auth', async data => {
      if (data.payload.event === 'signInWithRedirect') {
        await this.handleToken();
      }
    });

    this.handleToken();
  }

  private async handleToken() {
    try {
      const user = await getCurrentUser();
      const session = await fetchAuthSession();

      if (session.tokens) {
        const idTokenPayload = session.tokens.idToken?.payload;

        const username = idTokenPayload?.['cognito:username'] || user.username;
        const email = idTokenPayload?.['email'];
        const sub = idTokenPayload?.['sub'];
        const userOrganizations = idTokenPayload?.['custom:organizations'];
        const groups = (idTokenPayload?.['cognito:groups'] as string[]) ?? [];

        this.storageService.setUser({
          user: username as string,
          ruolo: groups[0],
          email: email as string,
          organizationPaths: [userOrganizations as string],
          sub: sub,
        });

        this.navigationService.loadPermissions().subscribe({
          next: () => this.router.navigate(['/archive']),
          error: () => this.router.navigate(['/archive']),   // il menu resta vuoto, ma l'app non si blocca
        });
      }
    } catch {
      // Nessuna sessione attiva
    }
  }
}
